import { useSelector } from 'react-redux';
import { ProductionBatchStatistics } from '@interfaces/search';
import { selectSingleBatch } from '@reducers/batch';

const useManageBatchBlockHeader = () => {
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);

  const batchStatusBadgeConfig = [
    {
      condition: batch && batch?.isInProgress,
      bg: 'ProdJobBatch/Light/Running Background',
      color: 'System/Light/Blue',
      text: 'Running',
      withDot: true,
    },
    {
      condition: batch && !batch?.isInProgress && !batch?.isClosed,
      bg: 'ProdJobBatch/Light/Paused Background',
      color: 'ProdJobBatch/Light/Paused',
      text: 'Paused',
      withDot: false,
    },
    {
      condition: batch && batch?.isClosed,
      bg: 'Gray/Light/6',
      color: 'Label/Light/Primary',
      text: 'Finished',
      withDot: false,
    },
  ];

  const currentBatchStatusBadgeConfig = batchStatusBadgeConfig.filter((c) => c.condition)?.[0];

  return { batchStatusBadgeConfig: currentBatchStatusBadgeConfig, batchNumber: batch?.batchNumber };
};

export { useManageBatchBlockHeader };
